import { Outlet } from 'react-router';
import { RoleBasedGuard } from '@classroom-ai/ui/auth/guard';
import { useAuthContext } from '@classroom-ai/ui/auth/hooks';
import { SplashScreen } from '@classroom-ai/ui/components/loading-screen';

// ----------------------------------------------------------------------

/**
 * Wraps the class-scoped dashboard routes (sessions, class roster, curriculum,
 * standards, reviews, lesson plans). SCHOOL_STAFF and ED360_STAFF pass through;
 * DISTRICT_ADMIN — who has no class context (ClassProvider yields empty lists) —
 * gets the RoleBasedGuard denied view instead of an endless loading state. The
 * nav already hides these items for them; this is the direct-URL backstop. Epic #76.
 */
export function SchoolStaffGuard() {
  const { user, loading } = useAuthContext();

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <RoleBasedGuard
      currentRole={user?.role ?? ''}
      allowedRoles={['SCHOOL_STAFF', 'ED360_STAFF']}
      hasContent
    >
      <Outlet />
    </RoleBasedGuard>
  );
}
